import { computed, inject, Injectable, signal } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { GlobalAppApi } from '@features/global/api/global-app.api';
import { GlobalAppSettings, InstallationRegion } from '@features/global/global-app.model';

@Injectable({ providedIn: 'root' })
export class GlobalAppSettingsService {
  private api = inject(GlobalAppApi);

  private settings$ = signal<GlobalAppSettings>(null);

  readonly region$ = computed<InstallationRegion>(() => this.settings$()?.region ?? 'rf');

  load(): Observable<GlobalAppSettings> {
    return this.api.get().pipe(
      map((state) => state.settings),
      tap((settings) => this.settings$.set(settings)),
    );
  }
}
